<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2 text-center">
      <h2 class="mb-2 text-center">Claim your account</h2>
      As part of your invitation, you have received a 6-digit code.  Enter it below along with your new password.
    </div>
    <v-form ref="form" @submit.prevent="verifyClick">
      <v-otp-input 
        length="6" class="mb-4"
        type="number"
        v-model="code"
        :rules="[required, valid_code]"
        tabindex="1"
      />

      <v-text-field
        v-model="password"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Choose your Password"
        :rules="[required, valid_password]"
        validate-on-blur tabindex="2"
        placeholder=" " persistent-placeholder
        autocomplete="new-password" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />
      <v-text-field
        v-model="confirmation"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Confirm Password"
        :rules="[required, matches_password]"
        validate-on-blur tabindex=3
        placeholder=" " persistent-placeholder
        autocomplete="new-confirm" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />

      <div class="px-2" style="font-size: 13px">
        By checking the box below, I acknowledge that I have <strong>read</strong> and <strong>agree</strong>
        to the terms of the PartnerLists 
        <router-link :to="{'name': 'login/eula'}">Referrer EULA</router-link> and 
        <router-link :to="{'name': 'login/privacy'}">Privacy Policy</router-link>.
      </div>
      <div class="d-flex flex-column align-center">
        <v-checkbox v-model="accepted"
          label="I have read and agree."
          :rules="[required]"
          hide-details="true"
          class="pb-6"
        />  
      </div>

      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Set Your Password</v-btn>
      </div>
    </v-form>
    <ErrorOverlay title="Password Reset Error" v-model="error_dialog" :loading="loading">
      {{ error_message }}
    </ErrorOverlay>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, valid_code, valid_password, matches } from '@/lib/validations'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'Verify',

  mixins: [ ErrorOverlayMixin ],

  props: ['id'],

  data() {
    return {
      code: '',
      password: '',
      confirmation: '',
      accepted: false,
      pw_visible: false,

      // validation rules
      required,
      valid_code,
      valid_password,
    }
  },

  computed: {
    // validation rules requiring access to data
    matches_password() { return matches(this.password, 'Password') }
  },

  methods: {
    ...mapActions('auth', ['resetPassword']),

    async verifyClick() {
      if (this.$refs.form.validate()) {
        
        let payload = { 
          user_id: this.id,
          password_recovery_code: this.code,
          password: this.password,
          accepted: true,
        }

        this.loading = true
        const result = await this.resetPassword(payload)
        this.loading = false

        if (result.ok) {
          this.$router.replace({ name: 'login/welcome' })
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>
